import { render, staticRenderFns } from "./ImageEmptyState.vue?vue&type=template&id=b600562a&"
import script from "./ImageEmptyState.vue?vue&type=script&lang=ts&"
export * from "./ImageEmptyState.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports